import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 支付记录 — 流水, 只读.
 */
export const paymentsConfig: CrudConfig = {
  resource: 'payments',
  title: '支付记录',
  rowKey: 'id',
  searchFields: ['payment_no', 'status', 'channel'],
  disableCreate: true,
  disableEdit: true,
  disableDelete: true,
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, readonly: true },
    { name: 'payment_no', label: '支付单号', type: 'text', copyable: true, width: 200, readonly: true },
    { name: 'order_no', label: '订单号', type: 'text', copyable: true, width: 180, readonly: true },
    {
      name: 'channel',
      label: '支付渠道',
      type: 'select',
      width: 140,
      readonly: true,
      options: [
        { label: 'Airwallex', value: 'AIRWALLEX', color: 'blue' },
        { label: '支付宝', value: 'ALIPAY', color: 'cyan' },
        { label: '微信支付', value: 'WECHAT', color: 'green' },
        { label: 'Stripe', value: 'STRIPE', color: 'purple' },
        { label: 'Mock', value: 'MOCK' },
      ],
    },
    {
      name: 'status',
      label: '状态',
      type: 'select',
      width: 120,
      readonly: true,
      options: [
        { label: '等待中', value: 'PENDING', status: 'Default' },
        { label: '处理中', value: 'PROCESSING', status: 'Processing', color: 'blue' },
        { label: '成功', value: 'SUCCEEDED', status: 'Success', color: 'green' },
        { label: '失败', value: 'FAILED', status: 'Error', color: 'red' },
        { label: '已退款', value: 'REFUNDED', status: 'Warning', color: 'orange' },
      ],
    },
    { name: 'amount', label: '金额', type: 'number', width: 120, readonly: true },
    { name: 'currency', label: '币种', type: 'text', width: 80, readonly: true },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true },
    { name: 'updated_at', label: '更新时间', type: 'datetime', width: 180, readonly: true, hideInTable: true },
  ],
};
